import { module } from "../../../../__sharedLibs/wallet";

export default module;
